import { hotBoards, talkTopics } from "@/mocks/home";

export default function HotAndTalk() {
  return (
    <section id="hot" className="scroll-mt-24 bg-background-50">
      <div className="mx-auto w-full max-w-7xl px-4 py-16 md:px-6 md:py-24">
        {/* 热门板块 */}
        <div>
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-primary-100 px-3 py-1 text-xs font-medium text-primary-700">
                <i className="ri-fire-fill" aria-hidden="true" />大家都在看
              </span>
              <h2 className="mt-4 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">热门板块</h2>
            </div>
            <p className="text-sm text-foreground-500">按今日讨论热度排序 · 更新于刚刚</p>
          </div>

          <div className="mt-7 grid grid-cols-1 gap-3 sm:grid-cols-2 lg:grid-cols-3">
            {hotBoards.map((b) => (
              <div key={b.rank} className="flex items-center justify-between rounded-xl border border-background-200 bg-background-50 px-5 py-4 transition-colors hover:border-primary-200">
                <div className="flex items-center gap-4">
                  <span className={`font-brand text-2xl ${Number(b.rank) <= 3 ? "text-primary-500" : "text-background-300"}`}>
                    {b.rank}
                  </span>
                  <div>
                    <h3 className="text-sm font-semibold text-foreground-950">{b.name}</h3>
                    <p className="text-xs text-foreground-400">{b.count}</p>
                  </div>
                </div>
                <span className={`flex items-center gap-1 text-xs font-medium ${b.up ? "text-secondary-600" : "text-foreground-400"}`}>
                  <i className={b.up ? "ri-arrow-up-line" : "ri-arrow-down-line"} aria-hidden="true" />
                  {b.trend}
                </span>
              </div>
            ))}
          </div>
        </div>

        {/* 社区热聊 */}
        <div id="talk" className="mt-16 scroll-mt-24 md:mt-20">
          <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <span className="inline-flex items-center gap-2 rounded-full bg-secondary-100 px-3 py-1 text-xs font-medium text-secondary-700">
                <i className="ri-chat-3-line" aria-hidden="true" />评论区很热闹
              </span>
              <h2 className="mt-4 text-2xl font-black tracking-tight text-foreground-950 md:text-4xl">社区热聊</h2>
              <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600">
                追更找新料的路上别只顾着收，来热聊里互相补档、催更和种草，好内容常常藏在回复里。
              </p>
            </div>
            <a href="#talk" className="inline-flex items-center gap-1 whitespace-nowrap text-sm font-medium text-secondary-600 hover:text-secondary-700">
              进入讨论区 <i className="ri-arrow-right-line" aria-hidden="true" />
            </a>
          </div>

          <div className="mt-7 divide-y divide-background-100 overflow-hidden rounded-xl border border-background-200 bg-background-50">
            {talkTopics.map((t) => (
              <article key={t.title} className="flex flex-col gap-2 px-5 py-4 transition-colors hover:bg-background-100/60 sm:flex-row sm:items-center sm:gap-4 sm:px-6">
                <span className="w-fit whitespace-nowrap rounded bg-secondary-100 px-2 py-0.5 text-[11px] text-secondary-700">{t.board}</span>
                <a href="#talk" className="flex-1 truncate text-sm text-foreground-900 hover:text-primary-700">
                  {t.title}
                </a>
                <div className="flex items-center gap-4 text-xs text-foreground-400 whitespace-nowrap">
                  <span className="flex items-center gap-1"><i className="ri-message-2-line" aria-hidden="true" />{t.replies}</span>
                  <span className="hidden sm:inline">{t.time}</span>
                  <span className="hidden md:inline text-foreground-500">by {t.author}</span>
                </div>
              </article>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}